export class AvailableQuestionnaire {
    questions: AvailableQuestion[];
    questionsPosition: {[key: string]: number};
}

export class AvailableQuestion {
    code: string;
    version: number;
    description: string;
    openEndedQuestion: boolean;
    answersPosition: {[key: string]: number};
    answers: AvailableAnswer[];
}

export class AvailableAnswer {
    code: string;
    version: number;
    description: string;
}

export class FilledQuestionnaire {
    questions: FilledQuestion[];

    constructor(props = {}) {
        Object.assign(this, props);
    }
}

export class FilledQuestion {
    code: string;
    version: number;
    description: string;
    answers: FilledQuestionAnswer[];

    constructor(props = {}) {
        Object.assign(this, props);
    }
}

export class FilledQuestionAnswer {
    code: string;
    version: number;
    fixedDescription: string;
    userInput: string;
    selected: boolean;

    constructor(props = {}) {
        Object.assign(this, props);
    }
}

export class FilledQuestionnaireRequest {
    answers: AnsweredQuestionRequest[];

    constructor(props = {}) {
        Object.assign(this, props);
    }
}

export class AnsweredQuestionRequest {
    questionCode: string;
    questionVersion: number;
    answerCode: string;
    answerVersion: number;
    userInput: string;

    constructor(props = {}) {
        Object.assign(this, props);
    }
}
